export default __webpack_public_path__ + "static/t60-842731712749e47b9bc675ecafda6cb0.webp";